/**
 * Service Worker Registration
 * Registers the service worker for PWA functionality
 */

const handleStateChange = (installingWorker: ServiceWorker) => {
  if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
    console.log('[ServiceWorker] New content available, please refresh.');
    
    // Optional: Show update notification to user
    if (globalThis.confirm('Nueva versión disponible. ¿Recargar la página?')) {
      installingWorker.postMessage({ type: 'SKIP_WAITING' });
      globalThis.location.reload();
    }
  }
};

const handleUpdateFound = (registration: ServiceWorkerRegistration) => {
  const installingWorker = registration.installing;
  if (installingWorker) {
    installingWorker.addEventListener('statechange', () => handleStateChange(installingWorker));
  }
};

const handleRegistration = (registration: ServiceWorkerRegistration) => {
  console.log('[ServiceWorker] Registered successfully:', registration.scope);

  // Check for updates every hour
  setInterval(() => {
    registration.update();
  }, 1000 * 60 * 60);

  // Listen for updates
  registration.addEventListener('updatefound', () => handleUpdateFound(registration));
};

export function register() {
  if ('serviceWorker' in navigator) {
    globalThis.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then(handleRegistration)
        .catch((error) => {
          console.error('[ServiceWorker] Registration failed:', error);
        });

      // Reload page when new service worker takes control
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        globalThis.location.reload();
      });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[ServiceWorker] Unregistration error:', error.message);
      });
  }
}
